// modal opener and other logic
if (!customElements.get('klaviyo-modal')) {
  customElements.define('klaviyo-modal', class KlaviyoBackInStockModal extends HTMLElement {
    constructor() {
      super();
      this.triggerButton = document.querySelector('.klaviyo-back-in-stock-button');
      this.closeButton = this.querySelector('.klaviyo-modal-close');
      this.closeButtonText = this.querySelector('.klaviyo-modal-close-text');     
      this.bodyEl = document.querySelector('body');
      this.overlayEl = document.querySelector('.klaviyo-modal-page-overlay');

      this.submitButton = document.querySelector('.klaviyo-subscribe-button');

      this.productID = this.dataset.productId
      this.productVariantID = this.dataset.productVariantId;
      this.inputValue = this.querySelector('.klaviyo-subscriber-email')

      this.buttonSpinner = this.querySelector('.klaviyo-subscribe-button .loading-overlay__spinner')
      this.buttonCopy = this.querySelector('.klaviyo-subscribe-button span');

      this.data = {};
    }

    connectedCallback() {
      if(this.triggerButton) {
        this.triggerButton.addEventListener('click', this.openModal.bind(this))
        this.closeButton.addEventListener('click', this.closeModal.bind(this))
        this.closeButtonText.addEventListener('click', this.closeModal.bind(this))
        this.overlayEl.addEventListener('click', this.closeModal.bind(this))
        this.submitButton.addEventListener('click', this.fetchSub.bind(this))
      }
    }

    setData() {
      this.data = {
        "a":"YaQudf",
        "email":this.inputValue.value,
        "variant":Number(this.productVariantID),
        "product":Number(this.productID),
        "platform":"shopify"
    };
    }

    fetchSub() {
      //logic

      this.buttonCopy.classList.add('hidden');
      this.buttonSpinner.classList.remove('hidden');
      this.submitButton.setAttribute('disabled', 'disabled');

      this.setData();
          
     

      const myHeaders = new Headers({
        "revision": "2024-07-15",
        "Content-Type": "application/json",
        "Accept": "application/json"
      });

      const raw = JSON.stringify({
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            channels: ["EMAIL"],
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: this.data.email
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${window.QF.productId}`
              }
            }
          }
        }
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };


      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.data.a}`, requestOptions)
          .then(response => response.text())
          .then(result => {
              document.querySelector('klaviyo-modal .step-form').classList.add('hidden')
              document.querySelector('klaviyo-modal .step-success').classList.remove('hidden')
              this.submitButton.removeAttribute('disabled');
              this.buttonCopy.classList.remove('hidden');
              this.buttonSpinner.classList.add('hidden');
          })
          .catch(error => {
              document.querySelector('klaviyo-modal .step-form').classList.add('hidden')
              document.querySelector('klaviyo-modal .step-error').classList.remove('hidden')
              this.submitButton.removeAttribute('disabled');
              this.buttonCopy.classList.remove('hidden');
              this.buttonSpinner.classList.add('hidden');
          });
      // logic end
    }

    openModal() {
      this.classList.add('show');
      this.overlayEl.classList.add('show');
    }

    closeModal() {
      this.classList.remove('show');
      document.querySelector('klaviyo-modal .step-form').classList.remove('hidden')
      document.querySelector('klaviyo-modal .step-error').classList.add('hidden')
      document.querySelector('klaviyo-modal .step-success').classList.add('hidden')
      document.querySelector('.klaviyo-subscriber-email').value = '';
      this.overlayEl.classList.remove('show');
    }

  }
)};
